import { Matrix4 } from 'three'
export const BOARD_ATTRACTION_SCALE=1.5
// Scale around the board surface, then relocate the display without changing its height above the board.
export function boardAttractionMatrix(cx:number,cz:number,x:number,z:number){return new Matrix4().makeTranslation(x,.49,z).multiply(new Matrix4().makeScale(BOARD_ATTRACTION_SCALE,BOARD_ATTRACTION_SCALE,BOARD_ATTRACTION_SCALE)).multiply(new Matrix4().makeTranslation(-cx,-.49,-cz))}
export const boardEdition = (name:string) => `${name} Edition`
